const glamcornerDomainRegExp = new RegExp("https?://[.a-zA-Z]*[.]glamcorner.com.au[:0-9]*");

function nonGlamCornerDomain(origin) {
  return !glamcornerDomainRegExp.test(origin);
}

export function handlePostMessage(event) {
  if (nonGlamCornerDomain(event.origin)) {
    return;
  }

  const message = event.data;
  if (message.type !== "broadcast") {
    return;
  }

  const { eventName, eventData } = message.data;
  GlamCornerCore.bus.broadcast(eventName, eventData);
}
